import {i18n} from '@online-offer/i18n';

import {SectionPrint} from '../../components/SectionPrint/SectionPrint';
import {useGetOnlineOfferData} from '../../hooks/useGetOnlineOfferData';
import {getRatingCardParams} from '../../utils/getRatingCardParams';
import {CertificateBadge} from './CertificateBadge';

export function CertificatePrint() {
  const {vehicleAudit} = useGetOnlineOfferData();
  const audit = vehicleAudit?.audit;
  const ratings = getRatingCardParams(vehicleAudit);

  if (!audit && !ratings) {
    return null;
  }

  return (
    <SectionPrint heading={i18n.t('certificate.heading')}>
      <CertificateBadge
        title={i18n.t('certificate.badge.title')}
        digitalCertificateVehicleId={audit?.id}
        ratings={ratings}
      />
    </SectionPrint>
  );
}
